__webpack_require__.p = "/academic-pages/dist/";